import React, { useEffect, useRef } from "react";
import { supabase } from "../lib/supabase";
import { endpoints } from "../lib/api";
import { Loader2 } from "lucide-react";

// Supabase PKCE redirect lands here with ?code=... in the URL. The supabase-js
// client auto-detects this and exchanges the code for a session via
// `detectSessionInUrl: true`. We just need to wait for the session, then
// bootstrap the Mongo user/gym profile (idempotent) and go to the dashboard.
export default function AuthCallback() {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    (async () => {
      try {
        // Give detectSessionInUrl a tick to consume the ?code= or #access_token
        const start = Date.now();
        let session = null;
        while (Date.now() - start < 8000) {
          const { data } = await supabase.auth.getSession();
          if (data?.session) { session = data.session; break; }
          await new Promise(r => setTimeout(r, 200));
        }
        if (!session) {
          window.location.replace("/login");
          return;
        }
        // Idempotent: creates the Mongo user + gym on first login.
        try { await endpoints.oauthComplete({}); } catch {}
        window.location.replace("/dashboard");
      } catch {
        window.location.replace("/login");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Loader2 className="w-5 h-5 animate-spin text-primary" />
        <p className="text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
